import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class TeleteamRouteMatcher implements CanMatch {

  constructor(private session: SessionService) { }

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    // might wait for an API call
    const companyId = this.session.getToken()?.companyId || NaN;
    if(companyId === 100261 // Teleteam Test 
      || companyId === 98054 // Teleteam Prod 
     ) return true;
    return false;
  }
}